export const aiPurpleGradientBackground = (opacity = 1) =>
  `linear-gradient(to right, rgba(224, 101, 255, ${opacity}), rgba(151, 71, 255, ${opacity}))`;

export const fileThumbFooterGradient = `linear-gradient(to bottom, rgba(102, 102, 102, 0), rgba(0, 0, 0, 0.4))`;

export const BOX_SHADOW =
  "0 8px 12px 6px rgba(0, 0, 0, 0.15), 0 4px 4px 0 rgba(0, 0, 0, 0.14)";

const colors = {
  black: "#000000",
  blackSecondary: "#323232",
  blackTertiary: "#041723",
  white: "#FFFFFF",
  whiteSecondary: "#FBF9F9",
  whiteTertiary: "#F5F5F5",
  orangePrimary: "#F16431",
  orangeSecondary: "#F5405B",
  orangeDark: "#FF7A59",
  orange10: "#FFF1E0",
  orange20: "#FEEFEA",
  orange30: "#FCE0D6",
  orange40: "#F7A283",
  grayMain: "#848484",
  grayPrimary: "#D6D6D6",
  graySecondary: "#F1F1F1",
  grayTertiary: "#898A8D",
  gray0: "#EBEBEB",
  gray5: "#E5E5E5",
  gray10: "#6B6B6B",
  gray20: "#D1D1D1",
  gray25: "#D0D4E5",
  gray30: "#ADADAD",
  gray40: "#8990A3",
  gray50: "#5B5B5B",
  gray60: "#DADADA",
  gray70: "#7E7D8F",
  gray80: "#D3CECE",
  gray90: "#555555",
  blue: "#007AFF",
  blueZip: "#1D9AD2",
  blueLight: "#E5F2FF",
  blueLightDarkened: "#cce5fe",
  blueLighter: "#CCE4FF",
  blue10: "#66AFFF",
  blue20: "#F2F8FF",
  blue30: "#194A93",
  blue40: "#99CAFF",
  blue50: "#535169",
  blue60: "#3395FF",
  darkBlue: "#282644",
  darkBlue20: "#D4D4DA",
  happycoBlue: "#282466",
  blueGreen: "#068799",
  blueGreen10: "#E6F3F5",
  blueGreen20: "#F3F9FA",
  blueGreen30: "#6AB7C2",
  yellow: "#FFEC99",
  yellowLight: "#FFFAE5",
  yellowDark: "#FF9500",
  yellow10: "#FFF5CC",
  yellow20: "#FFF4E5",
  yellow30: "#FFEACC",
  yellow40: "#FFD599",
  yellow50: "#FFBF66",
  yellow100: "#FFCF00",
  // commonBorderColor: rgba(214, 212, 212, 0.5);
  placeholderText: "#ADA7A7",
  messageBackground: "#EDEEEF",
  messageBackgroundSelf: "#E6EFFC",
  greenPrimary: "#40BF62",
  green10: "#D9F2E0",
  green20: "#ECF9EF",
  green30: "#B3E5C0",
  green40: "#66CC81",
  green50: "#8CD9A1",
  red: "#E94545",
  redLight: "#FDECEC",
  redDark: "#ED6A6A",
  red10: "#F28F8F",
  red20: "#FEF4F4",
  red30: "#FBDADA",
  red40: "#F6B5B5",
  yellowReaction: "#FFEACD",
  transparentWhite: "rgba(255, 255, 255, 0.85)",
  transparent: "rgba(0, 0, 0, 0)",
  transparent70Percent: "rgba(0, 0, 0, 0.7)",
  textPlaceholder: "#999",
  purple10: "#6E41CF",
  purple20: "#8B67D9",
  purple30: "#E2D9F5",
  purple40: "#645AFF",
  purple50: "#E0DEFF",
  aiPurpleGradient: {
    background: aiPurpleGradientBackground(),
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  aiPurpleRight: "#9747FF",
};

export default colors;
